export default __webpack_public_path__ + "static/media/results.86a33ad8.webp";